<template>
  <div
    class="m-msg-outer"
    @mouseleave="$emit('close')"
  >
    <div class="m-toper"></div>
    <div class="m-message-wrap">
      <div class="m-msg-header">
        <span class="m-msg-tt">{{
          msgOrTodo === "msg" && msgTotal > 0
          ? `${$t("common.message")}（${msgTotal}${$t("common.msg_total")}）`
          : msgOrTodo === "msg" && msgTotal === 0
          ? $t("common.message")
          : $t("common.todo")
          }}</span>
        <el-button
          type="iconButton"
          class="u-read-all"
          v-if="msgOrTodo === 'msg'"
          icon="iconfont icon-b_ic_yidu"
          @click="_handleReadAll"
          :disabled="msgTotal === 0"
        >{{ $t("common.sign_all_read") }}</el-button>
      </div>
      <div
        class="m-main-ctn"
        v-loading="loading"
      >
        <el-scrollbar
          wrap-class="m-msg-scroll-wrap"
          @on-scrolling="changeScroll"
          ref="scrollWrap"
        >
          <template v-if="msgOrTodo === 'msg'">
            <message-column
              @read="handleRead"
              v-for="(item, index) in list"
              :info="item"
              :key="index"
            ></message-column>
            <div
              class="m-no-more"
              v-if="msgPageTotal === pagination.pageNo && msgTotal > 7"
            >
              {{ $t("common.no_more") }}
            </div>
          </template>
          <template v-if="msgOrTodo === 'todo'">
            <todo-column
              v-for="(item, index) in list"
              :info="item"
              @goto="handleOpenApp"
              :key="index"
            ></todo-column>
          </template>
          <div
            class="m-no-data"
            v-if="list && list.length === 0"
          >
            <img src="../../assets/images/no_data_tlnc.png" /><br />
            {{ $t("common.no_data") }}
          </div>
        </el-scrollbar>
      </div>
      <div class="m-msg-footer">
        <el-button @click="handleShowTlnc()">{{
          msgOrTodo === "msg"
          ? $t("common.read_all_msg")
          : $t("common.read_all_todo")
          }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import messageColumn from './message-column'
import todoColumn from './todo-column'
import API from '../../api/api'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      list: [],
      pagination: {
        pageNo: 1,
        pageSize: 10
      },
      loading: false,
      msgTotal: 0,
      msgPageTotal: 1
    }
  },
  props: {
    msgOrTodo: {
      default: 'msg',
      type: String
    },
    wrapStatus: { default: false, type: Boolean }
  },
  components: { messageColumn, todoColumn },
  computed: {
    ...mapGetters(['tlnc'])
  },
  watch: {
    msgOrTodo () {
      this.getDataList()
    },
    wrapStatus (val) {
      if (val) {
        this.pagination = {
          pageNo: 1,
          pageSize: 10
        }
        this.getDataList()
      }
    }
  },
  methods: {
    // vuex
    ...mapActions(['openApp']),
    handleRead () {
      this.getDataList()
      this.$emit('refreshCount')
    },
    handleOpenApp (info) {
      window.goToApp(info)
      this.$emit('close')
      this.$emit('refreshCount')
    },
    changeScroll (scroll) {
      if (this.msgOrTodo === 'msg' && scroll.percentY === 1 && this.pagination.pageNo < this.msgPageTotal) {
        this.pagination.pageNo++
        this.getDataList(true)
      }
    },
    getDataList () {
      this.loading = true
      let Fn = 'getMsgList'
      let params
      if (this.msgOrTodo === 'msg') {
        Fn = 'getMsgList'
      } else {
        Fn = 'getTodoList'
        params = {
          size: 10
        }
      }
      API.common[Fn](params).then(res => {
        this.loading = false
        if (this.msgOrTodo === 'msg') {
          this.list = this._changeMsgCreateTime(res.data.list || [])
          this.msgTotal = res.data.total || 0
          this.msgPageTotal = res.data.totalPage
        } else {
          this.list = res.data
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err.msg)
      }).then(() => {
        this.$refs.scrollWrap.update()
      })
    },
    _handleReadAll () {
      API.common.markedReadAll().then(res => {
        this.getDataList()
        this.$emit('refreshCount')
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    handleShowTlnc () {
      let tlnc = this.msgOrTodo === 'msg' ? this.$store.state.messageMenuId : this.$store.state.todoMenuId
      if (tlnc) {
        this.openApp({
          value: tlnc,
          key: 'menuId'
        })
      } else {
        this.$message.error(this.$t('common.no_menu_id'))
      }
      this.$emit('close')
    },
    _changeMsgCreateTime (list) {
      return list.map(_ => {
        return {
          ..._,
          msgCreateTime: this._verifyTime(_.msgCreateTimeIso, _.serverTime)
        }
      })
    },
    /* 处理 今天、昨天等 特殊需求
    * @params *sourcTime 待的参数 为标准 ISO 时间戳 - 分隔日期 eg: 2019-10-31T14:23:30.000+08:00
    * @params curTime 时间戳 eg: new Date().getTime()
    */
    _verifyTime (sourceTime, curTime) {
      let result = ''
      // 未传 curTime 时，使用本地. 本地化，需要处理一下
      curTime = curTime ? new Date(curTime).toISOString() : new Date().toISOString()

      sourceTime = this._formatTime(sourceTime)
      curTime = this._formatTime(curTime)

      // 得到日期时间戳。TS = timeStamp
      let oldTS = moment(sourceTime).format('YYYY-MM-DD')
      let curTS = moment(curTime).format('YYYY-MM-DD')
      // 对比
      let dayDiff = parseInt(moment(curTS).format('x')) - parseInt(moment(oldTS).format('x'))
      // 按天计
      switch (dayDiff / (1000 * 60 * 60 * 24)) {
        // case 用来产生不同天的需求
        case 0:
          result = this.$t('components.widgetHomepage.tlnc.card_time_today')
          break
        case 1:
          result = this.$t('components.widgetHomepage.tlnc.card_time_yesterday')
          break
        default:
          break
      }
      return result === '' ? sourceTime : (sourceTime.replace(oldTS, result))
    },
    _formatTime (isoTime, isEnableDST) {
      if (!isoTime) return ''
      isEnableDST = arguments.length === 1 ? window.localStorage.getItem('isEnableDST') : isEnableDST
      const momentTime = moment(isoTime)
      return momentTime
        .utcOffset(0 - new Date().getTimezoneOffset())
        .format(isEnableDST ? 'YYYY-MM-DD HH:mm Z' : 'YYYY-MM-DD HH:mm')
    }
  }
}
</script>
<style lang="less" scoped>
.m-msg-outer {
  position: fixed;
  width: 376px;
  height: 516px;
  z-index: 101;
  .m-toper {
    width: 100%;
    height: 36px;
  }
  .m-message-wrap {
    width: 376px;
    height: 480px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    .m-msg-header {
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 #e0e0e0;
      .m-msg-tt {
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.9);
        line-height: 40px;
        margin-left: 16px;
      }
      .u-read-all {
        float: right;
        margin-top: 4px;
        margin-right: 16px;
      }
    }
    .m-main-ctn {
      width: 100%;
      height: calc(~"100% - 96px");
      box-sizing: border-box;
      padding: 8px 0;
      /deep/ .m-msg-scroll-wrap {
        position: absolute !important;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        .m-no-more {
          font-size: 12px;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: rgba(0, 0, 0, 0.2);
        }
        .m-no-data {
          margin-top: 130px;
          text-align: center;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.4);
          img {
            width: 72px;
          }
        }
      }
    }
    .m-msg-footer {
      width: 100%;
      height: 56px;
      background: rgba(0, 0, 0, 0.02);
      text-align: center;
      line-height: 56px;
    }
  }
}
</style>
